//import firebase from "firebase";
import firebase from 'firebase/app';
import 'firebase/app';
import 'firebase/firestore';
import 'firebase/storage';

var config = {
    apiKey: "AIzaSyB973ppjP1x-6dpq3R8pOle4-_PdB4EgeE",
    authDomain: "voda-214510.firebaseapp.com",
    databaseURL: "https://voda-214510.firebaseio.com",
    projectId: "voda-214510",
    storageBucket: "voda-214510.appspot.com",
    messagingSenderId: "32401544561"
  };

var app = firebase.initializeApp(config);
var firestore = app.firestore();
firestore.settings({ timestampsInSnapshots: true });
var storage = app.storage();

export { firestore, storage };
export default app;


// WEBPACK FOOTER //
// ./src/initfb.js